import IHttpClientPostParameters from '../contracts/http-client/http-client-post-parameters.interface'
import HttpClient from './http-client.service'
import Container, { Service } from 'typedi'
import IHttpClientPutParameters from '../contracts/http-client/http-client-put-parameters.interface'

// Browsers are unreliable about `File.type` for font files: Chrome reports
// an empty string for .ttf, and the legacy "application/font-woff" (not
// "font/woff") for .woff - neither of which matches the API's mime
// whitelist (MimeTypeValidationTrait::getAllowedMimeTypes). Rather than
// enumerate every browser's quirky variant, always trust the extension for
// known font types and ignore whatever the browser reported. Non-font files
// keep using the browser-reported type as before.
const EXTENSION_CONTENT_TYPES: Record<string, string> = {
  ttf: 'font/ttf',
  otf: 'font/otf',
  woff: 'font/woff',
  woff2: 'font/woff2'
}

export function resolveContentType (fileData: any): string {
  const extension: string = (fileData.name || '').split('.').pop()?.toLowerCase() || ''
  const fontContentType = EXTENSION_CONTENT_TYPES[extension]
  if (fontContentType) {
    return fontContentType
  }
  return fileData.type || 'application/octet-stream'
}

@Service()
export default class FileUploadService {
  public async uploadFile (fileData: any): Promise<any> {
    const contentType = resolveContentType(fileData)
    const vaporData: any = {
      bucket: '',
      content_type: contentType,
      expires: '',
      file_name: fileData.name
    }
    let signedResponse: any = {}
    let headers: any = {}

    // #region  Vapor Request
    const httpParamsVapor: IHttpClientPostParameters = {
      url: '/vapor/signed-storage-url',
      requireToken: true,
      payload: vaporData
    }
    const responseVapor: any = await Container.get(HttpClient).post(httpParamsVapor)
    signedResponse = responseVapor.data
    signedResponse.file_name = fileData.name
    headers = responseVapor.data.headers
    delete headers.Host
    headers['Content-Type'] = contentType
    // #endregion

    // #region File Request
    const httpParamsFile: IHttpClientPutParameters = {
      url: signedResponse.url,
      requireToken: false,
      payload: fileData,
      config: {
        headers
      }
    }
    await Container.get(HttpClient).put(httpParamsFile)
    return signedResponse
    // #endregion
  }
}
